import { render, staticRenderFns } from "./reportReview.vue?vue&type=template&id=81dba4b0&scoped=true"
import script from "./reportReview.vue?vue&type=script&lang=js"
export * from "./reportReview.vue?vue&type=script&lang=js"
import style0 from "./reportReview.vue?vue&type=style&index=0&id=81dba4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dba4b0",
  null
  
)

export default component.exports